import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { Container } from '@design-system/container';
import { Col, Grid, GridRow } from '@design-system/grid';
import { useBreakpoint, useTheme, useUpdateThemeWithFontBrightness, } from '@design-system/theme';
import { TemplateContainer } from './TemplateContainer';
import { BLOCKS, BlockWrapper, } from '../shared';
import { DEFAULT_ZONE } from '../utils';
export const ZONE_IDS = {
    appHeader: 'appHeader',
    headerControls: 'headerControls',
    filters: 'filters',
    slider: 'slider',
    tags: 'tags',
    empty: 'empty',
    side: 'side',
};
const DEFAULT_ZONES = {
    appHeader: [BLOCKS.appHeader.id],
    headerControls: [BLOCKS.headerControls.id],
    filters: [BLOCKS.filters.id],
    slider: [BLOCKS.slider.id],
    tags: [BLOCKS.tags.id],
    empty: [BLOCKS.emptyContent.id],
    side: [BLOCKS.side.id],
};
const OneColumnTemplate = ({ colOffset = 0, colWidth = 1, hasFilters, topicId, variant, zones, }) => {
    var _a;
    const breakpoint = useBreakpoint();
    const isDesktop = breakpoint === 'xl' || breakpoint === 'l';
    const theme = useTheme();
    const { headerSeparatorDisplay, secondaryNavigationBackgroundColor, secondaryNavigationFontBrightness } = theme.themeVariables;
    const updatedThemeForSecondaryNavigation = useUpdateThemeWithFontBrightness(theme, secondaryNavigationFontBrightness);
    return (_jsxs(TemplateContainer, { id: "one-column-template", children: [!topicId && zones[ZONE_IDS.appHeader] && (_jsx(BlockWrapper, { withShadow: headerSeparatorDisplay && variant !== 'max' && !hasFilters, children: zones[ZONE_IDS.appHeader] })), zones[ZONE_IDS.headerControls] && (_jsx(Container, { children: _jsx(Grid, { width: "100%", children: _jsx(GridRow, { children: _jsx(Col, { width: 1, children: _jsx(BlockWrapper, { mb: -3, mt: 8, children: zones[ZONE_IDS.headerControls] }) }) }) }) })), zones[ZONE_IDS.filters] && (_jsx(ThemeProvider, { theme: updatedThemeForSecondaryNavigation, children: _jsx(BlockWrapper, { bg: secondaryNavigationBackgroundColor, py: 6, withShadow: headerSeparatorDisplay, children: _jsx(Container, { display: "block", height: "auto", children: _jsx(Grid, { rowGap: 0, children: _jsx(GridRow, { children: _jsx(Col, { offset: colOffset, width: colWidth, children: zones[ZONE_IDS.filters] }) }) }) }) }) })), _jsx(Container, { display: "block", height: "auto", children: _jsxs(Grid, { rowGap: 0, children: [zones[ZONE_IDS.slider] ? (_jsx(GridRow, { children: _jsx(Col, { offset: colOffset, width: colWidth, children: _jsx(BlockWrapper, { "$emptyStyle": { marginTop: 0 }, mt: 6, children: zones[ZONE_IDS.slider] }) }) })) : null, zones[ZONE_IDS.tags] ? (_jsx(GridRow, { children: _jsx(Col, { offset: colOffset, width: colWidth, children: _jsx(BlockWrapper, { "$emptyStyle": { marginTop: 0 }, mt: 13, children: zones[ZONE_IDS.tags] }) }) })) : null, _jsxs(GridRow, { children: [_jsxs(Col, { offset: colOffset, width: zones[ZONE_IDS.side]
                                        ? {
                                            _: 1,
                                            l: 8 / 12,
                                            xl: 9 / 12,
                                        }
                                        : colWidth, children: [(_a = zones[DEFAULT_ZONE]) === null || _a === void 0 ? void 0 : _a.map((block, index) => (_jsx(BlockWrapper, { "$emptyStyle": { marginTop: 0 }, mt: 6, children: block }, index))), zones[ZONE_IDS.empty] && (_jsx(BlockWrapper, { mb: 10, mt: 6, children: zones[ZONE_IDS.empty] }))] }), zones[ZONE_IDS.side] && isDesktop ? (_jsx(Col, { offset: colOffset, width: {
                                        _: 0,
                                        l: 4 / 12,
                                        xl: 3 / 12,
                                    }, children: _jsx(BlockWrapper, { mt: 6, children: zones[ZONE_IDS.side] }) })) : null] })] }) })] }));
};
export default {
    id: 'one_column',
    zones: DEFAULT_ZONES,
    component: OneColumnTemplate,
};
//# sourceMappingURL=OneColumnTemplate.js.map